import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Form from 'react-bootstrap/Form';
import { useAsyncDebounce } from 'react-table';
import { colorAdditional, colorBackground, colorText, colorTextAdditional } from '@/utils/palette';

const ReactTableFilter = ({
  rows,
  setGlobalFilter, setFilterValue, placeholder, dataLength,
}) => {
  const onChange = useAsyncDebounce((item) => {
    const value = item.trim();
    setFilterValue(value);
    setGlobalFilter(value);
  }, 200);

  return (
    <SearchWrap>
      <SearchInput
        type="search"
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
      />
      {dataLength !== rows.length && (
        <span>Found {rows.length} matches</span>
      )}
    </SearchWrap>
  );
};

const filterGreaterThan = (rows, id, filterValue) => rows.filter((row) => {
  const rowValue = row.values[id];
  return rowValue >= filterValue;
});

filterGreaterThan.autoRemove = val => typeof val !== 'number';

ReactTableFilter.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  setFilterValue: PropTypes.func,
  placeholder: PropTypes.string,
  dataLength: PropTypes.number.isRequired,
};

ReactTableFilter.defaultProps = {
  setFilterValue: () => {},
  placeholder: 'Search...',
};

export default ReactTableFilter;

// region STYLES

const SearchWrap = styled.div`
  display: flex !important;
  align-items: baseline !important;
  margin-bottom: 30px !important;
  color: ${colorAdditional} !important;
`;

const SearchInput = styled(Form.Control)`
  height: 3em;
  max-width: 250px !important;
  font-size: 12px !important;
  margin-right: 20px !important;
  color: ${colorText} !important;
  background: ${colorBackground} !important;

  &:focus {
    color: ${colorTextAdditional} !important;
    background: white !important;
  };

  &::placeholder {
    color: ${colorText} !important;
  }
`;

// endregion
